import { EntityType, OrganisationPrimeBrokerDetail, TradingEntityMetaUpdate } from 'api'
import { sortBy } from 'lodash'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { tradingEntityMetaStoreSelector } from 'selectors/storeSelectors'
import { tradingEntityGetterSelector, tradingEntityMetasContainingPrimeBrokerSelector } from 'selectors/tradingEntitySelectors'
import { GlobalState } from 'store'
import { RepositoryEntry } from 'store/repository'

export const organisationPrimeBrokersDetailSelector: Selector<GlobalState, OrganisationPrimeBrokerDetail[]> = createSelector(
  tradingEntityMetaStoreSelector,
  tradingEntityMetasContainingPrimeBrokerSelector,
  tradingEntityGetterSelector,
  createEntityGetterSelector(EntityType.PRIME_BROKER),
  (allMetaEntries, tradingEntityMetas, getTradingEntity, getPrimeBroker) => {
    const primeBrokerDetails = tradingEntityMetas.flatMap(meta => {
      const entry: RepositoryEntry<TradingEntityMetaUpdate> | undefined = allMetaEntries[meta.id]
      const ownerTradingEntity = getTradingEntity(meta.ownerTradingEntityId)
      const subjectTradingEntity = getTradingEntity(meta.subjectTradingEntityId)
      const primeBroker = meta.primeBrokerId ? getPrimeBroker(meta.primeBrokerId) : null

      if (!ownerTradingEntity || !subjectTradingEntity || !entry || !primeBroker) return []

      return [
        {
          id: meta.id,
          ownerTradingEntity,
          subjectTradingEntity,
          primeBroker,
          availableEvents: entry.lastUpdate.availableEvents
        }
      ]
    })

    return sortBy(
      primeBrokerDetails,
      detail => detail.ownerTradingEntity.publishedName,
      detail => detail.subjectTradingEntity.publishedName,
      detail => detail.primeBroker.name
    )
  }
)
